module.exports = __webpack_public_path__ + "media/images/lb/321-ea82ecda66a308ad572e6079f3700641.svg";